var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { lazy } from 'react';
import StripContent from "../strips/stripContent";
var StripHeroImageBanner = lazy(function () { return import("../strips/stripHeroImageBanner"); });
import StripInfoProductCardContainer from "../strips/stripInfoProductCardContainer";
import StripVerticalColorAccordionContainer from "../strips/stripVerticalColorAccordionContainer";
import StripTextAndMedia from "../strips/stripTextAndMedia";
import StripHeroTextHeader from "../strips/stripHeroTextHeader";
import StripTabMenu from "../strips/stripTabMenu";
import StripBookingBar from "../strips/stripBookingBar";
import StripImageAndCard from "../strips/stripImageAndCard";
import StripStoryCardContainer from "../strips/stripStoryCardContainer";
import StripHeroStoriesContainer from "../strips/stripHeroStoriesContainer";
import StripSubscriptionForm from "../strips/stripSubscriptionForm";
import StripFAQContainer from "../strips/stripFAQContainer";
import StripImageCarousel from "../strips/StripImageCarousel";
import StripContentAccordion from "../strips/stripContentAccordion";
import StripTwoColumnContent from "../strips/stripTwoColumnContent";
import StripContentSliderContainer from "../strips/stripContentSliderContainer";
import StripImageDivider from "../strips/stripImageDivider";
import StripImageAndTextOverlay from "../strips/stripImageAndTextOverlay";
import StripSignUpBar from "../strips/stripSignUpBar";
export function getStripComponentFromStripData(stripData, otherProp) {
    if (otherProp === void 0) { otherProp = null; }
    if (!stripData)
        return null;
    switch (stripData.stripClassName) {
        case "sky23.content":
            return React.createElement(StripContent, __assign({ key: stripData.id, fields: stripData.fields, children: stripData.children }, otherProp));
        case "sky23.heroimagebanner":
            return React.createElement(StripHeroImageBanner, { key: stripData.id, fields: stripData.fields, children: stripData.children });
        case "sky23.infoproductcardcontainer":
            return React.createElement(StripInfoProductCardContainer, { key: stripData.id, fields: stripData.fields, children: stripData.children });
        case "sky23.verticalcoloraccordionparent":
            return React.createElement(StripVerticalColorAccordionContainer, { key: stripData.id, fields: stripData.fields, children: stripData.children });
        case "sky23.textandmedia":
            return React.createElement(StripTextAndMedia, { key: stripData.id, fields: stripData.fields, children: stripData.children });
        case "sky23.herotextheader":
            return React.createElement(StripHeroTextHeader, { key: stripData.id, fields: stripData.fields, children: stripData.children });
        case "sky23.tabcontainer":
            return React.createElement(StripTabMenu, { key: stripData.id, fields: stripData.fields, children: stripData.children });
        case "sky23.bookingbar":
            return React.createElement(StripBookingBar, { key: stripData.id, fields: stripData.fields, children: stripData.children });
        case "sky23.imageandcard":
            return React.createElement(StripImageAndCard, { key: stripData.id, fields: stripData.fields, children: stripData.children, labels: otherProp.labels });
        case "sky23.storiesfeed":
            return React.createElement(StripStoryCardContainer, { key: stripData.id, fields: stripData.fields });
        case "sky23.herostoriescontainer":
            return React.createElement(StripHeroStoriesContainer, { key: stripData.id, fields: stripData.fields, children: (stripData.fields && stripData.fields.dataSourceItems) ? stripData.fields.dataSourceItems : [] });
        case "sky23.herostoriescontainermanuallyselected":
            return React.createElement(StripHeroStoriesContainer, { key: stripData.id, fields: stripData.fields, children: (stripData.fields && stripData.fields.storiesSourceManuallySelected) ? stripData.fields.storiesSourceManuallySelected : [] });
        case "sky23.subscriptionform":
            return React.createElement(StripSubscriptionForm, { key: stripData.id, fields: stripData.fields });
        case "sky23.faqcontainer":
            return React.createElement(StripFAQContainer, { key: stripData.id, fields: stripData.fields, children: stripData.children });
        case "sky23.imagecarousel":
            return React.createElement(StripImageCarousel, { key: stripData.id, fields: stripData.fields, children: stripData.children });
        case "sky23.contentaccordion":
            return React.createElement(StripContentAccordion, { key: stripData.id, fields: stripData.fields, children: stripData.children });
        case "sky23.twocolumncontent":
            return React.createElement(StripTwoColumnContent, { key: stripData.id, fields: stripData.fields, children: stripData.children });
        case "sky23.twocolumncontent":
            return React.createElement(StripTwoColumnContent, { key: stripData.id, fields: stripData.fields, children: stripData.children });
        case "sky23.contentslidercontainer":
            return React.createElement(StripContentSliderContainer, { key: stripData.id, fields: stripData.fields, children: stripData.children });
        case "sky23.imagedivider":
            return React.createElement(StripImageDivider, { key: stripData.id, fields: stripData.fields });
        case "sky23.imageandtextoverlay":
            return React.createElement(StripImageAndTextOverlay, { key: stripData.id, fields: stripData.fields, children: stripData.children });
        case "sky23.signupbar":
            return React.createElement(StripSignUpBar, { key: stripData.id, fields: stripData.fields });
    }
    return null;
}
